import { sagaFunctions } from "../../config/helper";
import { apis } from "../../config/apis";
import { takeLatest } from "redux-saga/effects";
import {
  CustomerShipmentsList,
  CustomerPaymentTerms,
  CustomerShipmentTerms,
  CustomerShipmentDoc,
  CustomerBillingDoc,
  CustomerBillingList,
  CustomerShipmentTrack,
  SyncCustomerOrders,
  SyncCustomerDetails,
  CustomerShipmentDetails,
  Claims,
  SubmitClaims,
  CreditNotes,
  ClaimDetails,
  DocClaimsList,
  DownloadDocClaimList,
  ShipmentHistory,
  CustomerOnWaterReport,
  CustomerInvReport,
} from "./Action";

function customer_billing_doc(req) {
  return sagaFunctions(
    CustomerBillingDoc,
    "get",
    apis.customer_billing_doc,
    req.payload
  )();
}

function customer_billing_list(req) {
  return sagaFunctions(
    CustomerBillingList,
    "get",
    apis.customer_billing_list,
    req.payload
  )();
}

function customer_payment_terms(req) {
  return sagaFunctions(
    CustomerPaymentTerms,
    "get",
    apis.customer_payment_terms,
    req.payload
  )();
}

function customer_shipment_terms(req) {
  return sagaFunctions(
    CustomerShipmentTerms,
    "get",
    apis.customer_shipment_terms,
    req.payload
  )();
}

function get_claims(req) {
  return sagaFunctions(Claims, "get", apis.fetch_claim_list, req.payload)();
}

function get_claim_docs_list(req) {
  return sagaFunctions(
    DocClaimsList,
    "get",
    apis.claims_doc_list,
    req.payload
  )();
}

function download_claim(req) {
  return sagaFunctions(
    DownloadDocClaimList,
    "get",
    apis.download_claim_doc,
    req.payload
  )();
}

function get_claim(req) {
  return sagaFunctions(
    ClaimDetails,
    "get",
    apis.fetch_claim_details,
    req.payload
  )();
}
function get_shipment_history(req) {
  return sagaFunctions(
    ShipmentHistory,
    "get",
    apis.shipment_status_history,
    req.payload
  )();
}

function get_on_water_report(req) {
  return sagaFunctions(
    CustomerOnWaterReport,
    "get",
    apis.on_water_report,
    req.payload
  )();
}

function get_inv_report(req) {
  return sagaFunctions(
    CustomerInvReport,
    "get",
    apis.inventory_report,
    req.payload
  )();
}

function credit_notes(req) {
  return sagaFunctions(CreditNotes, "get", apis.credit_notes, req.payload)();
}

function create_claims(req) {
  return sagaFunctions(
    SubmitClaims,
    "post",
    `${apis.create_claim}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function customer_shipment_track(req) {
  return sagaFunctions(
    CustomerShipmentTrack,
    "get",
    apis.customer_shipment_track,
    req.payload
  )();
}

function customer_shipment_details(req) {
  return sagaFunctions(
    CustomerShipmentDetails,
    "get",
    apis.customer_shipment_details,
    req.payload
  )();
}

function customer_shipping_doc(req) {
  return sagaFunctions(
    CustomerShipmentDoc,
    "get",
    apis.customer_shipment_doc,
    req.payload
  )();
}

function customer_shipping_list(req) {
  return sagaFunctions(
    CustomerShipmentsList,
    "get",
    apis.customer_shipments_list,
    req.payload
  )();
}

function sync_customer_details(req) {
  return sagaFunctions(
    SyncCustomerDetails,
    "get",
    apis.sync_customer_details,
    req.payload
  )();
}

function sync_customer_orders(req) {
  return sagaFunctions(
    SyncCustomerOrders,
    "get",
    apis.sync_customer_orders,
    req.payload
  )();
}

export function* shipNPayWatcher() {
  yield takeLatest(CustomerBillingDoc.REQUEST, customer_billing_doc);
  yield takeLatest(Claims.REQUEST, get_claims);
  yield takeLatest(DownloadDocClaimList.REQUEST, download_claim);
  yield takeLatest(DocClaimsList.REQUEST, get_claim_docs_list);
  yield takeLatest(ClaimDetails.REQUEST, get_claim);
  yield takeLatest(SubmitClaims.REQUEST, create_claims);
  yield takeLatest(CreditNotes.REQUEST, credit_notes);
  yield takeLatest(CustomerBillingList.REQUEST, customer_billing_list);
  yield takeLatest(CustomerPaymentTerms.REQUEST, customer_payment_terms);
  yield takeLatest(CustomerShipmentTerms.REQUEST, customer_shipment_terms);
  yield takeLatest(CustomerShipmentTrack.REQUEST, customer_shipment_track);
  yield takeLatest(CustomerShipmentDetails.REQUEST, customer_shipment_details);
  yield takeLatest(CustomerShipmentDoc.REQUEST, customer_shipping_doc);
  yield takeLatest(CustomerShipmentsList.REQUEST, customer_shipping_list);
  yield takeLatest(SyncCustomerDetails.REQUEST, sync_customer_details);
  yield takeLatest(SyncCustomerOrders.REQUEST, sync_customer_orders);
  yield takeLatest(ShipmentHistory.REQUEST, get_shipment_history);
  yield takeLatest(CustomerOnWaterReport.REQUEST, get_on_water_report);
  yield takeLatest(CustomerInvReport.REQUEST, get_inv_report);
}
